import React, { useState } from 'react'

//MUI
import { Box, Button, Chip, Container, Fab, FormControlLabel, Grid, IconButton, Switch, TextField, Tooltip, Typography } from '@mui/material'
import AddIcon from '@mui/icons-material/Add';
import PreviewIcon from '@mui/icons-material/Preview';

//React new window
import NewWindow from 'react-new-window';

//React quill
import ReactQuill from 'react-quill';

//Components
import FormPreview from './FormPreview';
import { formats, modulesDescription, modulesSpeaker } from '../../../constants/formWebConstants';
import CustomToolbar from './CustomToolbar/CustomToolbar';

//Validator
import { NewWebFormValidator } from '../../../validators/NewWebFormValidator';

const init = {
    title: '',
    date: '',
    time: '',
    description: '',
    image: '',
    speakerName: '',
    speakerImg: '',
    speakerDescription: '',
    script: '',
    modality: '',
    specialties: [],
    isFinished: false
}

const AddWebinar = () => {
    const [formData, setFormData] = useState(init)
    const [specialty, setSpecialty] = useState('')
    const [img, setImg] = useState('');
    const [speakerImg, setSpeakerImg] = useState('')
    const [showPreview, setShowPreview] = useState(false)
    const today = new Date().toISOString().split("T")[0];

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleDescription = (value) => {
        setFormData({ ...formData, description: value });
    };

    const handleSpeakerDescription = (value) => {
        setFormData({ ...formData, speakerDescription: value });
    };

    const handleFinishedChange = (e) => {
        setFormData({
            ...formData,
            isFinished: e.target.checked
        });
    };

    const handleImgChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const url = URL.createObjectURL(file);
            setImg(url);
            setFormData((prev) => ({
                ...prev,
                image: file
            }));
        }
    };

    const handleSpeakerImgChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const url = URL.createObjectURL(file);
            setSpeakerImg(url);
            setFormData((prev) => ({
                ...prev,
                speakerImg: file
            }));
        }
    };

    const handleAddSpec = () => {
        if (specialty.trim() !== '') {
            setFormData((prev) => ({
                ...prev,
                specialties: [...prev.specialties, specialty.trim()]
            }));
            setSpecialty('');
        }
    };

    const handleDeleteSpec = (del) => {
        setFormData((prev) => ({
            ...prev,
            specialties: prev.specialties.filter((_, index) => index !== del)
        }));
    };

    const handleShowPreview = () => {
        setShowPreview(true)
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (NewWebFormValidator(formData)) {
            const load = JSON.parse(localStorage.getItem('webi')) || [];

            const newForm = {
                ...formData,
                image: null,
                speakerImg: null
            };

            load.push(newForm);
            localStorage.setItem('webi', JSON.stringify(load));
            alert('Guardar webinar');

            setFormData(init);
            setImg('');
            setSpeakerImg('');
        }
    };
    
    return (
        <Container maxWidth='xl' sx={{ mb: 5 }}>
            <Typography variant='h5' sx={{ fontWeight: '600', fontSize: '28px' }}>Formulario para añadir webinar</Typography>
            <Box sx={{ mt: 5, p: 3, boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px', borderRadius: '6px', mb: 8 }}>
                <Typography variant='h5' sx={{ fontWeight: 'bold', color: '#000C77', mb: 5 }}>Detalles del webinar</Typography>
                <Grid container spacing={4}>
                    <Grid item xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={formData.isFinished}
                                    onChange={handleFinishedChange}
                                    color="primary"
                                />
                            }
                            label="Marcar como terminado"
                        />
                    </Grid>
                    <Grid item xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <Typography variant='body1' sx={{ fontWeight: '500', color: '#707b7c', mb: .5 }}>Titulo</Typography>
                        <TextField
                            fullWidth
                            type="text"
                            name="title"
                            value={formData.title}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <Typography variant='body1' sx={{ fontWeight: '500', color: '#707b7c', mb: .5 }}>Imagen de portada para webinar</Typography>
                        <Box>
                            <Button
                                variant="contained"
                                component="label"
                                sx={{ textTransform: 'none', mb: 3 }}
                            >
                                Seleccionar imagen
                                <input
                                    accept="image/*"
                                    type="file"
                                    hidden
                                    onChange={handleImgChange}
                                />
                            </Button>
                            {img && (
                                <div>
                                    <img src={img} alt="Seleccionada" style={{ maxWidth: '200px', height: '200px', objectFit: 'cover' }} />
                                </div>
                            )}
                        </Box>
                    </Grid>
                    <Grid item xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <Typography variant='body1' sx={{ fontWeight: '500', color: '#707b7c', mb: .5 }}>Descripción de webinar</Typography>
                        <CustomToolbar id="toolbar-description" />
                        <ReactQuill
                            value={formData.description}
                            onChange={handleDescription}
                            modules={modulesDescription}
                            formats={formats}
                            theme="snow"
                        />
                    </Grid>
                    <Grid item xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                        <Typography variant='body1' sx={{ fontWeight: '500', color: '#707b7c', mb: .5 }}>Fecha</Typography>
                        <TextField
                            fullWidth
                            type="date"
                            name="date"
                            inputProps={{
                                min: today
                            }}
                            InputLabelProps={{ shrink: true }}
                            value={formData.date}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                        <Typography variant='body1' sx={{ fontWeight: '500', color: '#707b7c', mb: .5 }}>Hora</Typography>
                        <TextField
                            fullWidth
                            type="time"
                            name="time"
                            InputLabelProps={{ shrink: true }}
                            value={formData.time}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xxl={6} xl={6} lg={6} md={12} sm={12} xs={12}>
                        <Typography variant='body1' sx={{ fontWeight: '500', color: '#707b7c', mb: .5 }}>Tipo de modalidad</Typography>
                        <TextField
                            fullWidth
                            type="text"
                            name="modality"
                            value={formData.modality}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <Typography variant='body1' sx={{ fontWeight: '500', color: '#707b7c', mb: .5 }}>Script para registro</Typography>
                        <TextField
                            fullWidth
                            type="text"
                            name="script"
                            value={formData.script}
                            onChange={handleChange}
                        />
                    </Grid>
                </Grid>
            </Box>

            <Box sx={{ mt: 5, p: 3, boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px', borderRadius: '6px', mb: 6 }}>
                <Typography variant='h5' sx={{ fontWeight: 'bold', color: '#000C77', mb: 5 }}>Detalles del ponente</Typography>
                <Grid container spacing={4}>
                    <Grid item xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <Typography variant='body1' sx={{ fontWeight: '500', color: '#707b7c', mb: .5 }}>Nombre del ponente</Typography>
                        <TextField
                            fullWidth
                            type="text"
                            name="speakerName"
                            value={formData.speakerName}
                            onChange={handleChange}
                        />
                    </Grid>

                    <Grid item xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <Typography variant='body1' sx={{ fontWeight: '500', color: '#707b7c', mb: .5 }}>Imagen de ponente</Typography>
                        <Box>
                            <Button
                                variant="contained"
                                component="label"
                                sx={{ textTransform: 'none', mb: 3 }}
                            >
                                Seleccionar imagen
                                <input
                                    accept="image/*"
                                    type="file"
                                    hidden
                                    onChange={handleSpeakerImgChange}
                                />
                            </Button>
                            {speakerImg && (
                                <div>
                                    <img src={speakerImg} alt="Seleccionada" style={{ maxWidth: '200px', height: '200px', borderRadius: '50%', objectFit: 'cover' }} />
                                </div>
                            )}
                        </Box>
                    </Grid>

                    <Grid item xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <Typography variant='body1' sx={{ fontWeight: '500', color: '#707b7c', mb: .5 }}>Descripción del ponente</Typography>
                        <CustomToolbar id="toolbar-speaker" />
                        <ReactQuill
                            value={formData.speakerDescription}
                            onChange={handleSpeakerDescription}
                            modules={modulesSpeaker}
                            formats={formats}
                            theme="snow"
                        />
                    </Grid>

                    <Grid item xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <Typography variant='body1' sx={{ fontWeight: '500', color: '#707b7c', mb: .5 }}>Especialidades</Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap', gap: '12px' }}>
                            <Box sx={{ my: 'auto' }}>
                                <TextField
                                    sx={{ width: { xxl: '350px', xl: '350px', lg: '350px', md: '350px', sm: '350px', xs: '200px' } }}
                                    type="text"
                                    value={specialty}
                                    onChange={(e) => setSpecialty(e.target.value)}
                                />
                            </Box>
                            <Box sx={{ my: 'auto' }}>
                                <IconButton onClick={handleAddSpec}>
                                    <AddIcon />
                                </IconButton>
                            </Box>

                        </Box>
                        {formData.specialties.length > 0 && (
                            <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: '10px', flexWrap: 'wrap', mt: 2 }}>
                                {formData.specialties.map((res, index) => (
                                    <Chip
                                        key={index}
                                        color='success'
                                        label={res}
                                        onDelete={() => { handleDeleteSpec(index) }}
                                    />
                                ))}
                            </Box>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <Box>
                <Button variant='contained' size='large' onClick={handleSubmit}>Crear nuevo webinar</Button>
            </Box>

            <Tooltip title='Ver preview'>
                <Fab color="primary" aria-label="preview" onClick={handleShowPreview}
                    sx={{
                        position: "fixed",
                        bottom: '25px',
                        right: '35px',
                        '&:hover': {
                            color: '#fff',
                        },
                    }}
                >
                    <PreviewIcon />
                </Fab>
            </Tooltip>

            {showPreview && (
                <NewWindow onUnload={() => setShowPreview(false)} title="Vista previa del formulario">
                    <FormPreview formData={formData} img={img} speakerImg={speakerImg} />
                </NewWindow>
            )}
        </Container>
    )
}

export default AddWebinar